import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import Modals from "@components/shared/Modal/Modal";
import { AVAILIO_LOGO } from "@constants/assets";
import modalSlice from "@slices/modal.slice";

const AuthModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Modals
      footerClassName="fg-modal-footer"
      onClose={() => {
        dispatch(modalSlice.actions.updateAuthModal(false));
      }}
      data-testid="auth-modal-test"
      contentClassName="fg-modal-body-bg fg-double-bg"
      modalClassName="loginRegModal"
    >
      <div className="container-fluid fg-z-index-1 position-relative">
        <div className="fg-logo-within-shape">
          <img
            src={AVAILIO_LOGO}
            className="fg-logo-img"
            alt={t("availioTitle")}
          />
        </div>
      </div>
      <div className="container-fluid fg-z-index-1 position-relative btn-content-wrap">
        <div className="row">
          <div className="col-sm-12 col-md-6 col-xl-4 offset-md-3 offset-xl-4">
            <button
              data-testid={"auth-modal-login-button"}
              className="btn fg-btn fg-btn-filled-darkblue w-100"
              onClick={() => {
                dispatch(modalSlice.actions.updateLoginModal(true));
              }}
            >
              {t("login")}
            </button>
            <button
              data-testid={"auth-modal-register-button"}
              onClick={() => {
                dispatch(modalSlice.actions.updateRegisterModal(true));
              }}
              className="btn fg-btn fg-btn-border-darkblue w-100  "
            >
              {t("register")}
            </button>
          </div>
        </div>
      </div>
    </Modals>
  );
};

export default AuthModal;
